export default class Newspaper extends HTMLElement {
    constructor(m) {
        super(m);

        // UI
        this.$heading = this.querySelector('.c-heading.anim-stagger-words[data-has-animation]');
        this.$headingWords = this.$heading
            ? Array.from(this.$heading.querySelectorAll('[data-word]'))
            : [];
        this.wordsLength = this.$headingWords.length;
    }

    // =============================================================================
    // Lifecycle methods
    // =============================================================================
    connectedCallback() {
        this.wordsLength && this.style.setProperty('--anim-stagger-words-length', this.wordsLength);
    }

    disconnectedCallback() {}
}
